// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"127":"search-modal","764":"markdown"}[chunkId] || chunkId) + "-" + {"69":"62f295dd0909ec31c10d","127":"d26968f975f1aa5ded22","764":"a34a58926d4398a603a3"}[chunkId] + ".chunk.js";
};